import Vue from "vue";
import FixedOnScroll from "../classes/fixed-on-scroll";

import { Initializer } from "../interfaces/general";

export default class FixedOnScrollInitializer implements Initializer {
  public mount($: JQueryStatic, app: Vue) {
    new FixedOnScroll("#smalllogo", 0);
  }

  public unmount() {
    // nope
  }
}
